import { useState } from 'react';
import FloatingInput from '../components/FloatingInput';
import Spacer from '../components/Spacer';
import APIUrls from '../core/ApiUrls';
import Toastify from '../core/Toastify';
import { MakeAxiosRequest } from '../core/utils';
import LoginStateManager from '../core/LoginStateManager';
import { Navigate, useNavigate } from 'react-router-dom';

const Login = () => {
    const [email, setEmail] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const navigate = useNavigate();
    const [loading, setLoading] = useState<boolean>(false);

    const handleLogin = async () => {
        if (!email.trim() || !password.trim()) {
            Toastify.error('Fill All Required Fields');
            return;
        }
        const reqBody = {
            email,
            password,
        };
        setLoading(true);
        try {
            const res = await MakeAxiosRequest('POST', APIUrls.getURL('LOGIN'), reqBody);
            if (res?.data.data) {
                navigate(res?.data?.data?.redirect);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    if (LoginStateManager.isLoggedIn()) {
        return <Navigate to={'/dashboard'} />;
    }

    return (
        <div className="bg-[#f8f8f8] flex flex-col justify-center items-center h-screen w-screen">
            <h1 className="text-4xl font-bold text-center text-gray-800 mb-3">
                Clento <span className="text-purple-500">Reporter</span>
            </h1>
            <span className="text-purple-600 text-sm w-1/4 text-center mb-3">Track all important for you accounts, so you don’t miss anything important.</span>
            <div className="bg-white rounded-2xl shadow-xl p-10 border border-gray-100 w-full max-w-md flex flex-col items-center">
                <h1 className="text-3xl font-bold text-center text-gray-800 mb-6">Login</h1>
                <Spacer spacing={30} />
                <FloatingInput label="Email" type="email" value={email} onChange={setEmail} />
                <Spacer spacing={30} />
                <FloatingInput label="Password" type="password" value={password} onChange={setPassword} isPassword />
                <Spacer spacing={40} />
                <button disabled={loading} className="flex justify-center w-full bg-gradient-purple hover:hover-gradient-purple transition text-white py-3 rounded-xl font-semibold shadow-sm disabled:cursor-wait disabled:bg-slate-500" onClick={() => handleLogin()}>
                    {loading ? <div className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full" /> : 'Login'}
                </button>
                <div className="flex flex-row w-full text-center justify-center items-center mt-6">
                    <span className="text-sm">No account?&nbsp;</span>
                    <span className="text-sm text-purple-500 cursor-pointer" onClick={() => navigate('/signup')}>
                        Sign up
                    </span>
                </div>
            </div>
        </div>
    );
};

export default Login;
